module.exports = __webpack_public_path__ + "static/media/nike-cant-stop-that-dance.aea35003.mp4";